import { Box, CircularProgress, Container } from '@mui/material';
import React from 'react';
import { CONFIG } from '../config';

export interface SplashScreenProps {
  failure: string | null;
}

export const SplashScreen = (props: SplashScreenProps) => {
  const { failure } = props;
  return (
    <Container sx={{ marginTop: '20%', padding: 4 }} maxWidth={'xs'}>
      <Box
        sx={{
          fontSize: 28,
          fontWeight: 500,
          textAlign: 'center',
          marginBottom: 2,
        }}
      >
        Account Manager
      </Box>
      <Box sx={{ textAlign: 'center', marginBottom: 4 }}>{CONFIG.envName}</Box>
      <Box sx={{ textAlign: 'center' }}>
        {failure != null ? (
          <Box sx={{ color: 'red' }}>Erreur : {failure}</Box>
        ) : (
          <CircularProgress />
        )}
      </Box>
    </Container>
  );
};
